// extracted by mini-css-extract-plugin
export default {"filter":"AcademicVacation_filter__Dhop7","loading":"AcademicVacation_loading__MwTz4","search":"AcademicVacation_search__wtS7H"};